const minimumCacheTtlMilliseconds = 60_000;
const defaultCacheTtlMilliseconds = 60 * 60_000;

function cacheTtlMilliseconds(value) {
  const ttl = Number(value);

  if (!Number.isFinite(ttl)) {
    return defaultCacheTtlMilliseconds;
  }

  return Math.max(minimumCacheTtlMilliseconds, ttl);
}

function renderedAtMilliseconds(page) {
  return page.renderedAt?.toMillis?.() || 0;
}

function cacheStatus(page, cacheTtl) {
  return cacheState(page, cacheTtl).label;
}

function cacheState(page, cacheTtl, now = Date.now()) {
  if (page.renderStatus === 'rendering') {
    return {
      label: 'Refreshing',
      detail: renderedAtMilliseconds(page)
        ? 'Serving the existing cached page while a refresh runs.'
        : 'Rendering the first cached version.'
    };
  }

  if (page.renderStatus === 'failed') {
    return {
      label: 'Failed',
      detail: 'Serving the previous cached page and retrying on a later request.'
    };
  }

  if (!renderedAtMilliseconds(page)) {
    return {
      label: 'Unknown',
      detail: 'No completed render is recorded for this page.'
    };
  }

  if (now - renderedAtMilliseconds(page) >= cacheTtl) {
    return {
      label: 'Due',
      detail: 'The next request serves this cache and checks for updates in the background.'
    };
  }

  if (page.lastRefreshStrategy === 'validated') {
    return {
      label: 'Validated',
      detail: 'The source files and captured data were checked; the cached HTML is still valid.'
    };
  }

  return {
    label: 'Cached',
    detail: 'Serving cached HTML without checking the source until the cache TTL expires.'
  };
}

function isCacheablePagePath(path) {
  if (path.startsWith('/.')) {
    return false;
  }

  return !/\/[^/]*\.[^/]+$/.test(path) || /\.html?$/i.test(path);
}

module.exports = {
  cacheState,
  cacheStatus,
  cacheTtlMilliseconds,
  defaultCacheTtlMilliseconds,
  isCacheablePagePath,
  minimumCacheTtlMilliseconds,
  renderedAtMilliseconds
};
